import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgClass, NgFor, NgIf } from "@angular/common";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import moment from "moment";
import { Subject, firstValueFrom, takeUntil } from "rxjs";
import { Tickets } from "src/app/shared/model/tickets/tickets.model";
import { TicketsEstatus } from "src/app/utilerias/enums/tickets-estatus.enum";
import { TicketsService } from "../../tickets.service";
import { SolicitudTicketsEditComponent } from "../../solicitud/solicitud-tickets-edit/solicitud-tickets-edit.component";
import { Comentario } from "src/app/shared/model/tickets/comentario.model";
import { MensajesFijosEnum } from "src/app/utilerias/enums/mensajes-fijos-enum";
import { SweetAlertComponent } from "src/app/shared/SweetMesssage";
import { Evidencia } from "src/app/shared/model/tickets/evidencia.model";
import { EvidenciaViewerService } from "src/app/shared/services/evidencia-viewer.service";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { TicketMejora } from "src/app/shared/model/tickets/ticketMejora.model";
import { MejorasTicketsEditComponent } from "../../solicitud/mejoras-tickets-edit/mejoras-tickets-edit.component";
import { TicketCapacitacion } from "src/app/shared/model/tickets/ticketCapacitacion.model";
import { ModalTicketsComponent } from "./modal-tickets/modal-tickets.component";
import { TicketTipo } from "src/app/utilerias/enums/ticket-tipo.enum";
import { AuthService } from "src/app/security/auth.service";
import { UserSession } from "src/app/shared/model/core/UserSession.model";
import { TicketPerfil } from "src/app/shared/model/tickets/ticketperfil.model";

interface TicketEvidenceItem {
  evidencia: Evidencia;
  comentarioId: number;
  fecha: Date | string | null | undefined;
  nombreEstatus: string;
  nombreUsuario: string;
}

type TicketCommentItem = {
  id: number;
  descripcion: string;
  fecha: string;
  nombreUsuario: string;
  nombreEstatus: string;
  evidencias?: Evidencia[];
  listaEvidencia?: Evidencia[];
  _trackId: string;
  [key: string]: unknown;
};

@Component({
  selector: "app-detalle-tickets",
  standalone: true,
  templateUrl: "./detalle-tickets.component.html",
  styleUrls: ["./detalle-tickets.component.css"],
  imports: [
    MatButton,
    MatIconButton,
    MatIcon,
    MatTooltip,
    NgIf,
    NgFor,
    NgClass,
    ReactiveFormsModule,
  ],
})
export class DetalleTicketsComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly defaultReturnUrl = "/TICKETS/Admin";
  private readonly clientReturnUrl = "/TICKETS/Cte";
  private readonly shortMonthNames = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];

  @ViewChild("downloadDocument") private download!: ElementRef<HTMLAnchorElement>;

  tickets: Tickets = new Tickets();
  listComentario: TicketCommentItem[] = [];
  allEvidencias: TicketEvidenceItem[] = [];
  estatusllegaTiquet: TicketsEstatus | null = null;
  mejora: TicketMejora | null = null;
  ticketCapacitacion: TicketCapacitacion | null = null;
  ticketPerfil: TicketPerfil | null = null;
  returnUrl = this.defaultReturnUrl;
  esMejora = false;
  esCapacitacion = false;
  esPerfil = false;
  loading = true;
  nombreUsuarioLogeado = "";
  evidenciaComentario: File[] = [];
  submittingInlineComment = false;
  viewMode: "admin" | "client" = "admin";
  formComentario = new FormGroup({
    descripcion: new FormControl("", {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });
  private currentUserId: number | null = null;

  constructor(
    private dialog: MatDialog,
    private ticketService: TicketsService,
    private visorEvidencias: EvidenciaViewerService,
    private sanitizer: DomSanitizer,
    private mensaje: SweetAlertComponent,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private authS: AuthService
  ) {}

  ngOnInit(): void {
    this.cargarUsuarioLogeado();
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.resolveRouteContext(params);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCloseClick(): void {
    this.regresar();
  }

  regresar(): void {
    this.router.navigateByUrl(this.returnUrl || this.defaultReturnUrl);
  }

  avanzarDeEstatus(): void {
    this.abrirModalComentario({
      cambioEstatus: true,
      cambioDeEstatusCancelado: false,
      mostrarHoras: false,
      showDatosComplementarios: false,
    });
  }

  avanzarDeEstatusAtendido(): void {
    this.abrirModalComentario({
      cambioEstatus: true,
      cambioDeEstatusCancelado: false,
      mostrarHoras: true,
      showDatosComplementarios: true,
    });
  }

  ticketCancelado(): void {
    this.abrirModalComentario({
      cambioEstatus: false,
      cambioDeEstatusCancelado: true,
      mostrarHoras: true,
      showDatosComplementarios: false,
    });
  }

  solicitudTickets(): void {
    const tipo = this.getNormalizedType(this.tickets.tipoSolicitud);

    switch (tipo) {
      case Constantes.SOLICITUD_MEJORA:
        this.mejoraEdit();
        break;
      default:
        this.infraestEdit();
        break;
    }
  }

  cargarComentarioPorTicket(): void {
    if (!this.tickets.id_ticket) {
      this.listComentario = [];
      this.allEvidencias = [];
      this.refreshView();
      return;
    }

    const comentario = new Comentario();
    comentario.id_ticket = this.tickets.id_ticket;

    this.ticketService
      .consultarComentario(comentario)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res) {
            this.listComentario = Array.isArray(res.listComentario)
              ? res.listComentario.map((item: unknown, index: number) =>
                  this.normalizeComentario(item, index)
                )
              : [];
            this.refreshEvidenceIndex();
            this.refreshView();
            return;
          }

          this.listComentario = [];
          this.allEvidencias = [];
          this.mensaje.showSwal("error-message", MensajesFijosEnum.ERROR_SERVIDOR);
          this.refreshView();
        },
        error: () => {
          this.listComentario = [];
          this.allEvidencias = [];
          this.mensaje.showSwal("error-message", MensajesFijosEnum.ERROR_SERVIDOR);
          this.refreshView();
        },
      });
  }

  esPrevisualizable(evidencia: Evidencia): boolean {
    return this.visorEvidencias.esPrevisualizable(evidencia?.nombre);
  }

  iconoEvidencia(evidencia: Evidencia): string {
    return this.visorEvidencias.obtenIcono(evidencia?.nombre);
  }

  consultaEvidencia(evidencia: Evidencia): void {
    if (this.visorEvidencias.esImagen(evidencia?.nombre)) {
      this.muestraImagen(evidencia);
      return;
    }

    if (this.visorEvidencias.esVideo(evidencia?.nombre)) {
      this.muestraVideo(evidencia);
      return;
    }

    // Excel, PDF, Word, comprimidos, etc. no se pueden previsualizar:
    // se entregan directamente al usuario como descarga.
    this.descargaEvidencia(evidencia);
  }

  muestraImagen(evidencia: Evidencia): void {
    this.ticketService
      .verImagen(evidencia)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => this.visorEvidencias.abreImagen(evidencia.nombre, res),
        error: () => this.visorEvidencias.avisoNoDisponible(),
      });
  }

  muestraVideo(evidencia: Evidencia): void {
    firstValueFrom(this.ticketService.consultaVideoEvidencia(evidencia))
      .then((res) => this.visorEvidencias.abreVideo(evidencia.nombre, res))
      .catch(() => this.visorEvidencias.avisoNoDisponible());
  }

  descargaEvidencia(evidencia: Evidencia): void {
    this.ticketService
      .descargaArchivo(evidencia)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) =>
          this.visorEvidencias.descarga(evidencia.nombre, response),
        error: () => this.visorEvidencias.avisoNoDisponible(),
      });
  }

  canEditTicket(): boolean {
    return (
      this.viewMode === "admin" &&
      this.estatusllegaTiquet === TicketsEstatus.ABIERTA &&
      !this.esMejora
    );
  }

  canAddComment(): boolean {
    return ![
      TicketsEstatus.VOBO,
      TicketsEstatus.CANCELADA,
    ].includes(this.estatusllegaTiquet as TicketsEstatus);
  }

  canShowCommentComposer(): boolean {
    return this.canAddComment();
  }

  canSendInlineComment(): boolean {
    return (
      this.canShowCommentComposer() &&
      !this.submittingInlineComment &&
      !!this.formComentario.controls.descripcion.value.trim()
    );
  }

  canMoveToProcess(): boolean {
    return (
      this.viewMode === "admin" &&
      [
      TicketsEstatus.ABIERTA,
      TicketsEstatus.REABIERTA,
    ].includes(this.estatusllegaTiquet as TicketsEstatus)
    );
  }

  canMoveToAtendida(): boolean {
    return (
      this.viewMode === "admin" &&
      this.estatusllegaTiquet === TicketsEstatus.PROCESO
    );
  }

  canCancelTicket(): boolean {
    return (
      this.viewMode === "admin" &&
      [
      TicketsEstatus.ABIERTA,
      TicketsEstatus.PROCESO,
      TicketsEstatus.ATENDIDA,
      TicketsEstatus.REABIERTA,
    ].includes(this.estatusllegaTiquet as TicketsEstatus)
    );
  }

  canClientCloseTicket(): boolean {
    return (
      this.viewMode === "client" &&
      this.estatusllegaTiquet === TicketsEstatus.ATENDIDA
    );
  }

  canClientReopenTicket(): boolean {
    return (
      this.viewMode === "client" &&
      this.estatusllegaTiquet === TicketsEstatus.ATENDIDA
    );
  }

  canClientCancelTicket(): boolean {
    return (
      this.viewMode === "client" &&
      [
        TicketsEstatus.ABIERTA,
        TicketsEstatus.PROCESO,
        TicketsEstatus.ATENDIDA,
        TicketsEstatus.REABIERTA,
      ].includes(this.estatusllegaTiquet as TicketsEstatus)
    );
  }

  cerrarTicketCliente(): void {
    this.abrirModalComentario({
      cambioEstatus: true,
      cambioDeEstatusCancelado: false,
      cambioDeEstatusReabierto: false,
      mostrarHoras: false,
      showDatosComplementarios: false,
    });
  }

  reabrirTicketCliente(): void {
    this.abrirModalComentario({
      cambioEstatus: false,
      cambioDeEstatusCancelado: false,
      cambioDeEstatusReabierto: true,
      mostrarHoras: false,
      showDatosComplementarios: false,
    });
  }

  cancelarTicketCliente(): void {
    this.abrirModalComentario({
      cambioEstatus: false,
      cambioDeEstatusCancelado: true,
      cambioDeEstatusReabierto: false,
      mostrarHoras: false,
      showDatosComplementarios: false,
    });
  }

  getProfileAvailabilityLabel(): string {
    if (this.ticketPerfil?.recursoDisponible === true) {
      return "Disponible";
    }
    if (this.ticketPerfil?.recursoDisponible === false) {
      return "No disponible";
    }
    return "N/A";
  }

  getStatusColor(status?: string | String | null): string {
    switch (this.normalizeKey(status ?? this.tickets.nombreEstaus)) {
      case "ABIERTA":
      case "REABIERTA":
        return Constantes.ABIERTOCOLOR;
      case "PROCESO":
        return Constantes.PROCESOCOLOR;
      case "ATENDIDA":
        return Constantes.RESUELTOCOLOR;
      case "VOBO":
        return Constantes.VOBOCOLOR;
      case "CANCELADA":
        return Constantes.CANCELADOCOLOR;
      default:
        return "#475569";
    }
  }

  getPriorityColor(priority?: string | String | null): string {
    switch (this.normalizeKey(priority ?? this.tickets.prioridad)) {
      case "ALTA":
        return "#dc2626";
      case "MEDIA":
        return "#d97706";
      case "BAJA":
        return "#059669";
      default:
        return "#475569";
    }
  }

  getPriorityChipClass(priority?: string | String | null): string {
    switch (this.normalizeKey(priority ?? this.tickets.prioridad)) {
      case "ALTA":
        return "ticket-detalle-page__priority-chip--high";
      case "MEDIA":
        return "ticket-detalle-page__priority-chip--medium";
      case "BAJA":
        return "ticket-detalle-page__priority-chip--low";
      default:
        return "ticket-detalle-page__priority-chip--default";
    }
  }

  getStatusChipClass(status?: string | String | null): string {
    switch (this.normalizeKey(status ?? this.tickets.nombreEstaus)) {
      case "ABIERTA":
        return "ticket-detalle-page__status-chip--open";
      case "REABIERTA":
        return "ticket-detalle-page__status-chip--reopen";
      case "PROCESO":
        return "ticket-detalle-page__status-chip--process";
      case "ATENDIDA":
        return "ticket-detalle-page__status-chip--done";
      case "VOBO":
        return "ticket-detalle-page__status-chip--vobo";
      case "CANCELADA":
        return "ticket-detalle-page__status-chip--cancel";
      default:
        return "ticket-detalle-page__status-chip--default";
    }
  }

  getTypeChipClass(type?: string | String | null): string {
    switch (this.normalizeKey(type ?? this.tickets.tipoSolicitud)) {
      case Constantes.SOLICITUD_MEJORA:
        return "ticket-detalle-page__type-chip--mejora";
      case TicketTipo.CAPACITACION:
        return "ticket-detalle-page__type-chip--capacitacion";
      case TicketTipo.INFRAESTRUCTURA:
        return "ticket-detalle-page__type-chip--infra";
      case Constantes.SOLICITUD_PERFIL:
        return "ticket-detalle-page__type-chip--perfil";
      default:
        return "ticket-detalle-page__type-chip--default";
    }
  }

  getInitials(value: string | String | null | undefined): string {
    const text = String(value ?? "")
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((item) => item.charAt(0).toUpperCase())
      .join("");

    return text || "TK";
  }

  getSlaLabel(): string {
    if (this.tickets.cumpleSla) {
      return String(this.tickets.cumpleSla);
    }

    if (this.tickets.tiemp) {
      return this.tickets.tiemp;
    }

    return "Sin cálculo";
  }

  addCommentFiles(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) {
      return;
    }

    Array.from(input.files).forEach((file) => {
      const exists = this.evidenciaComentario.some(
        (current) => current.name === file.name && current.size === file.size
      );

      if (!exists) {
        this.evidenciaComentario.push(file);
      }
    });

    input.value = "";
    this.refreshView();
  }

  removeCommentFile(fileToRemove: File): void {
    this.evidenciaComentario = this.evidenciaComentario.filter(
      (file) =>
        !(
          file.name === fileToRemove.name && file.size === fileToRemove.size
        )
    );
    this.refreshView();
  }

  limpiarComentarioInline(): void {
    if (this.submittingInlineComment) {
      return;
    }

    this.formComentario.reset({ descripcion: "" });
    this.evidenciaComentario = [];
    this.refreshView();
  }

  saveInlineComment(): void {
    if (this.submittingInlineComment || !this.tickets.id_ticket) {
      return;
    }

    const descripcion = this.formComentario.controls.descripcion.value.trim();
    if (!descripcion) {
      this.mensaje.showSwal(
        "info-message2",
        MensajesFijosEnum.INCIDENCIA_DATOS_VACIOS
      );
      return;
    }

    this.submittingInlineComment = true;
    this.refreshView();

    this.resolveCurrentUserId()
      .then((userId) => {
        const comentario = new Comentario();
        comentario.descripcion = descripcion;
        comentario.id_ticket = this.tickets.id_ticket;
        comentario.id_estatus = this.tickets.id_estatus;
        comentario.id_usuario = userId;

        return firstValueFrom(this.ticketService.guardarComentario(comentario));
      })
      .then((response) => {
        const comentarioId = this.toNumber(response?.id);
        if (!comentarioId) {
          throw new Error("COMMENT_SAVE_FAILED");
        }

        return this.uploadInlineCommentFiles(comentarioId).then(() => response);
      })
      .then((response) => {
        this.ticketService.nuevoComentario(response);
        this.formComentario.reset({ descripcion: "" });
        this.evidenciaComentario = [];
        this.cargarComentarioPorTicket();
      })
      .catch(() => {
        this.mensaje.showSwal("error-message", MensajesFijosEnum.ERROR_SERVIDOR);
      })
      .finally(() => {
        this.submittingInlineComment = false;
        this.refreshView();
      });
  }

  getTimelineEvidencias(item: TicketCommentItem): Evidencia[] {
    const dynamicItem = item as TicketCommentItem;
    if (Array.isArray(dynamicItem.evidencias)) {
      return dynamicItem.evidencias;
    }

    if (Array.isArray(item.listaEvidencia)) {
      return item.listaEvidencia;
    }

    return [];
  }

  getEmpleadoNombre(empleado: any): string {
    const persona = empleado?.persona;
    return (
      persona?.nombreCompleto ||
      [persona?.nombre, persona?.apellidoPaterno, persona?.apellidoMaterno]
        .filter(Boolean)
        .join(" ")
        .trim() ||
      "Sin nombre"
    );
  }

  formatDetailDate(value: unknown): string {
    if (value === null || value === undefined) {
      return "";
    }

    const normalized = String(value).trim();
    if (!normalized) {
      return "";
    }

    const parsed = moment.parseZone(normalized, moment.ISO_8601, true);
    if (parsed.isValid()) {
      return this.buildFormattedDate(parsed);
    }

    const fallback = moment(normalized);
    if (fallback.isValid()) {
      return this.buildFormattedDate(fallback);
    }

    return normalized;
  }

  trackByComentarioId(_index: number, item: TicketCommentItem): string | number {
    return item._trackId || item.id || _index;
  }

  trackByEvidenceKey(_index: number, item: TicketEvidenceItem): string {
    return `${item.comentarioId}-${item.evidencia.id_evidencia}-${item.evidencia.nombre}`;
  }

  private resolveRouteContext(params: ParamMap): void {
    const state = history.state as {
      ticket?: Tickets;
      returnUrl?: string;
      viewMode?: "admin" | "client";
    } | null;
    const routeId = Number(params.get("id"));
    const routeMode =
      (this.route.snapshot.data?.["viewMode"] as "admin" | "client" | undefined) ??
      (this.route.snapshot.routeConfig?.path?.startsWith("DetalleWidget")
        ? "client"
        : "admin");
    this.viewMode = state?.viewMode === "client" || routeMode === "client" ? "client" : "admin";
    this.returnUrl =
      typeof state?.returnUrl === "string" && state.returnUrl.trim()
        ? state.returnUrl
        : typeof this.route.snapshot.data?.["returnUrl"] === "string" &&
            this.route.snapshot.data["returnUrl"].trim()
          ? this.route.snapshot.data["returnUrl"]
          : this.viewMode === "client"
            ? this.clientReturnUrl
            : this.defaultReturnUrl;

    if (state?.ticket?.id_ticket && (!routeId || state.ticket.id_ticket === routeId)) {
      this.hydrateTicket(state.ticket);
      this.cargarComentarioPorTicket();
      this.loadSupplementaryData();

      if (!state.ticket.justificacion || !state.ticket.nombreEstaus) {
        this.loadTicketById(state.ticket.id_ticket);
      } else {
        this.loading = false;
        this.refreshView();
      }
      return;
    }

    if (routeId > 0) {
      this.loadTicketById(routeId);
      return;
    }

    this.loading = false;
    this.refreshView();
    this.regresar();
  }

  private loadTicketById(idTicket: number): void {
    this.loading = true;
    this.ticketService
      .consultarDetalle({ id_ticket: idTicket })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (response) {
            const mergedTicket = Object.assign(
              new Tickets(),
              history.state?.ticket ?? {},
              response
            );
            this.hydrateTicket(mergedTicket);
            this.cargarComentarioPorTicket();
            this.loadSupplementaryData();
            this.refreshView();
            return;
          }

          this.mensaje.showSwal("error-message", MensajesFijosEnum.ERROR_SERVIDOR);
          this.refreshView();
          this.regresar();
        },
        error: () => {
          this.loading = false;
          this.mensaje.showSwal("error-message", MensajesFijosEnum.ERROR_SERVIDOR);
          this.refreshView();
          this.regresar();
        },
      });
  }

  private hydrateTicket(ticket: Tickets): void {
    this.tickets = Object.assign(new Tickets(), ticket);
    if (!this.tickets.fechaSolicitudConFormato && this.tickets.fechaSolicitud) {
      this.tickets.fechaSolicitudConFormato = String(this.tickets.fechaSolicitud);
    }

    this.estatusllegaTiquet = this.tickets.id_estatus;
    const tipoNormalizado = this.getNormalizedType(this.tickets.tipoSolicitud);
    this.esMejora = tipoNormalizado === Constantes.SOLICITUD_MEJORA;
    this.esCapacitacion = tipoNormalizado === TicketTipo.CAPACITACION;
    this.esPerfil = tipoNormalizado === Constantes.SOLICITUD_PERFIL;

    if (!this.esMejora) {
      this.mejora = null;
    }

    if (!this.esCapacitacion) {
      this.ticketCapacitacion = null;
    }

    if (!this.esPerfil) {
      this.ticketPerfil = null;
    }

    this.refreshView();
  }

  private loadSupplementaryData(): void {
    if (!this.tickets.id_ticket) {
      return;
    }

    if (this.esMejora) {
      this.consultaMejora();
    }

    if (this.esCapacitacion) {
      this.consultaCapacitacion();
    }

    if (this.esPerfil) {
      this.consultaPerfil();
    }
  }

  private consultaMejora(): void {
    const consulta = new Tickets();
    consulta.id_ticket = this.tickets.id_ticket;

    this.ticketService
      .consultarDetalleMejora(consulta)
      .pipe(takeUntil(this.destroy$))
      .subscribe((mejoraRes) => {
        this.mejora = mejoraRes ?? null;
        this.refreshView();
      });
  }

  private consultaCapacitacion(): void {
    this.ticketService
      .consultarDetalleCapacitacionTicket(this.tickets.id_ticket)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resultado) => {
        if (resultado && resultado.pCodRetorno === "00000") {
          this.ticketCapacitacion = resultado;
          this.refreshView();
          return;
        }

        this.ticketCapacitacion = null;
        this.refreshView();
      });
  }

  private consultaPerfil(): void {
    this.ticketService
      .consultarDetallePerfilTicket(this.tickets.id_ticket)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resultado) => {
        if (resultado && resultado.pCodRetorno === "00000") {
          this.ticketPerfil = resultado;
          this.refreshView();
          return;
        }

        this.ticketPerfil = null;
        this.refreshView();
      });
  }

  private infraestEdit(): void {
    this.dialog
      .open(SolicitudTicketsEditComponent, {
        disableClose: true,
        autoFocus: true,
        width: "60%",
        panelClass: "custom-modalbox",
        data: {
          datos: this.tickets,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.reloadCurrentTicket();
      });
  }

  private mejoraEdit(): void {
    this.dialog
      .open(MejorasTicketsEditComponent, {
        disableClose: true,
        autoFocus: true,
        width: "60%",
        panelClass: "custom-modalbox",
        data: {
          datos: this.mejora,
          desc:
            this.listComentario.length > 0
              ? this.listComentario[this.listComentario.length - 1].descripcion ?? ""
              : "",
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.reloadCurrentTicket();
      });
  }

  private abrirModalComentario(config: {
    cambioEstatus: boolean;
    cambioDeEstatusCancelado: boolean;
    cambioDeEstatusReabierto?: boolean;
    mostrarHoras: boolean;
    showDatosComplementarios: boolean;
  }): void {
    this.dialog
      .open(ModalTicketsComponent, {
        disableClose: true,
        autoFocus: true,
        width: "60%",
        panelClass: "custom-modalbox",
        data: {
          datos: this.tickets,
          cambioEstatus: config.cambioEstatus,
          cambioDeEstatusCancelado: config.cambioDeEstatusCancelado,
          cambioDeEstatusReabierto: !!config.cambioDeEstatusReabierto,
          redireccionamiento: this.viewMode === "client" ? "/Cte" : "/Admin",
          mostrarHoras: config.mostrarHoras,
          showDatosComplementarios: config.showDatosComplementarios,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value !== null && value !== undefined) {
          this.ticketService.nuevoComentario(value);
          this.ticketService.nuevoEstatus(this.tickets);
          this.reloadCurrentTicket();
          this.mensaje.showSwal("success-message", null);
        }
      });
  }

  private reloadCurrentTicket(): void {
    if (!this.tickets.id_ticket) {
      return;
    }

    this.loadTicketById(this.tickets.id_ticket);
  }

  private refreshEvidenceIndex(): void {
    this.allEvidencias = this.listComentario.flatMap((comentario) =>
      this.getTimelineEvidencias(comentario).map((evidencia) => ({
        evidencia,
        comentarioId: comentario.id,
        fecha: comentario.fecha,
        nombreEstatus: String(comentario.nombreEstatus ?? ""),
        nombreUsuario: String(comentario.nombreUsuario ?? ""),
      }))
    );
  }

  private getNormalizedType(type: string | String | null | undefined): string {
    return this.normalizeKey(type);
  }

  private normalizeKey(value: string | String | null | undefined): string {
    return String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toUpperCase();
  }

  private normalizeComentario(raw: unknown, index: number): TicketCommentItem {
    const source = (raw ?? {}) as Record<string, unknown>;
    const evidencias = Array.isArray(source["evidencias"])
      ? (source["evidencias"] as Evidencia[])
      : Array.isArray(source["listaEvidencia"])
        ? (source["listaEvidencia"] as Evidencia[])
        : [];

    return {
      ...source,
      id: this.toNumber(source["id"]) ?? index + 1,
      descripcion: String(
        source["descripcion"] ??
          source["comentario"] ??
          source["detalle"] ??
          ""
      ).trim(),
      fecha: String(source["fecha"] ?? source["fechaComentario"] ?? "").trim(),
      nombreUsuario: String(
        source["nombreUsuario"] ??
          source["usuario"] ??
          source["autor"] ??
          "Sistema"
      ).trim(),
      nombreEstatus: String(
        source["nombreEstatus"] ?? source["estatus"] ?? ""
      ).trim(),
      evidencias,
      listaEvidencia: evidencias,
      _trackId: `${this.toNumber(source["id"]) ?? index + 1}-${index}`,
    };
  }

  private toNumber(value: unknown): number | null {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private cargarUsuarioLogeado(): void {
    try {
      this.setCurrentUserContext(this.authS.getCosData());
    } catch {
      this.currentUserId = null;
      this.nombreUsuarioLogeado = "";
    }

    if (this.currentUserId && this.nombreUsuarioLogeado) {
      return;
    }

    this.authS
      .getSesion()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (session) => {
          this.setCurrentUserContext(session);
          this.refreshView();
        },
      });
  }

  private setCurrentUserContext(session: UserSession | null | undefined): void {
    this.currentUserId = this.toNumber(
      session?.usuario?.id ?? session?.idUsuarioSession
    );
    this.nombreUsuarioLogeado = this.buildUserName(session);
  }

  private buildUserName(session: UserSession | null | undefined): string {
    const persona = session?.persona;
    return (
      persona?.nombreCompleto ||
      [persona?.nombre, persona?.apellidoPaterno, persona?.apellidoMaterno]
        .filter(Boolean)
        .join(" ")
        .trim() ||
      ""
    );
  }

  private async resolveCurrentUserId(): Promise<number> {
    if (this.currentUserId) {
      return this.currentUserId;
    }

    const session = await firstValueFrom(this.authS.getSesion());
    this.setCurrentUserContext(session);

    if (!this.currentUserId) {
      throw new Error("SESSION_USER_MISSING");
    }

    return this.currentUserId;
  }

  private uploadInlineCommentFiles(comentarioId: number): Promise<void> {
    if (!this.evidenciaComentario.length) {
      return Promise.resolve();
    }

    const formData = new FormData();
    this.evidenciaComentario.forEach((file) => {
      formData.append("file", file, `$${comentarioId}$${file.name}`);
    });

    return new Promise((resolve, reject) => {
      this.ticketService.uploadEvidencia(formData).subscribe({
        complete: () => resolve(),
        error: () => reject(new Error("COMMENT_UPLOAD_FAILED")),
      });
    });
  }

  private refreshView(): void {
    queueMicrotask(() => {
      try {
        this.cdr.detectChanges();
      } catch {
        // No-op if the view was destroyed between scheduling and execution.
      }
    });
  }

  private buildFormattedDate(dateValue: moment.Moment): string {
    const month = this.shortMonthNames[dateValue.month()] ?? "";
    const hours = String(dateValue.hour()).padStart(2, "0");
    const minutes = String(dateValue.minute()).padStart(2, "0");
    return `${dateValue.date()} ${month} ${dateValue.year()} ${hours}:${minutes}`;
  }
}
